import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { formMappings } from "../../../config/formMappings";

export default function AgeDistributionTable() {
  const entries = useSelector((state: RootState) => state.formEntries.entries);

  const activeFormName = useSelector(
    (state: RootState) => state.formEntries.activeFormName || ""
  );

  const formMapping = formMappings[activeFormName as keyof typeof formMappings];
  const ageFieldKey = formMapping?.fieldMappings?.Age || "i6b3v3";

  // Calculate age distribution by individual age
  const ageDistribution = entries.reduce((acc, entry) => {
    // First, try to find registrants in the mapped "Registrants" key
    if (entry.meta.Registrants) {
      Object.values(entry.meta.Registrants)
        .filter((registrant) => registrant && (registrant as any)[ageFieldKey])
        .forEach((registrant) => {
          const age = parseInt((registrant as any)[ageFieldKey], 10);
          if (!isNaN(age)) {
            acc[age] = (acc[age] || 0) + 1;
          }
        });
    } else {
      // Fallback: look for registrants in keys starting with "9v3kh" (registrants container)
      const registrantsKey = Object.keys(entry.meta).find(
        (key) => key.startsWith("9v3kh") && typeof entry.meta[key] === "object"
      );

      if (registrantsKey) {
        const registrantsContainer = entry.meta[registrantsKey] as any;
        if (registrantsContainer) {
          Object.values(registrantsContainer)
            .filter(
              (item: any) =>
                item &&
                typeof item === "object" &&
                item[ageFieldKey] &&
                item[ageFieldKey] !== "form"
            )
            .forEach((registrant: any) => {
              const age = parseInt(registrant[ageFieldKey], 10);
              if (!isNaN(age)) {
                acc[age] = (acc[age] || 0) + 1;
              }
            });
        }
      }
    }
    return acc;
  }, {} as { [age: number]: number });

  const ageDistributions = Object.entries(ageDistribution).map(
    ([age, count]) => ({
      name: age,
      value: count,
    })
  );

  return (
    <div className="overflow-y-scroll rounded-lg bg-white shadow no-scrollbar">
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
            >
              Age
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Count
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {ageDistributions.map((ageDistribution, idx) => (
            <tr key={idx}>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                {ageDistribution.name}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                {ageDistribution.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
